import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import SendIcon from "../icon/SendIcon";
import * as Animatable from "react-native-animatable";
import RemoveIcon from "../icon/RemoveIcon";
import { useEffect } from "react";
import { useState } from "react";
import Theme from "app/constants/Theme";
import theme from "app/Theme/Theme";
import { MainText } from "app/components/common";

const styles = StyleSheet.create({
  main: {
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    backgroundColor: "#FAFAFA",
    height: 50,
    width: "100%",
    paddingHorizontal: 10,
  },
  loadingView: {
    backgroundColor: "#007EFC",
    height: 30,
    marginRight: 5,
    borderRadius: 15,
    paddingRight: 10,
    paddingLeft: 5,
    width: "90%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexDirection: "row",
  },
  waves: {
    flex: 1,
    marginRight: 10,
    height: 8,
    borderRadius: 8,
    width: "90%",
    backgroundColor: theme.colors["neutral.white"],
  },
  dotsContainer: {
    flex: 1,
    overflow: "hidden",
    flexDirection: "row",
    marginRight: 10,
    paddingLeft: 8,
    paddingRight: 8,
    height: 8,
    borderRadius: 8,
    width: "90%",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  dot: {
    height: 6,
    width: 6,
    marginRight: 3,
    borderRadius: 5,
    backgroundColor: theme.colors["neutral.white"],
  },
});

interface Props {
  cancelAudio: () => void;
  sendAudio: () => void;
}

const AudioRecordingBar = ({ cancelAudio, sendAudio }: Props) => {
  const [dots, setDots] = useState<number[]>([]);

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prevDots => [...prevDots, 1]);
    }, 100);

    return () => clearInterval(interval);
  }, []);

  return (
    <View style={styles.main}>
      <View style={styles.loadingView}>
        <TouchableOpacity onPress={cancelAudio}>
          <RemoveIcon />
        </TouchableOpacity>
        <View style={styles.dotsContainer}>
          {dots.map((el, index) => {
            return (
              <Animatable.View
                key={index}
                style={styles.dot}
                animation={"bounceIn"}
                useNativeDriver
              />
            );
          })}
        </View>
        <MainText color="neutral.white">{dots?.length / 10}</MainText>
      </View>

      <TouchableOpacity onPress={sendAudio} hitSlop={Theme.HITSLOP}>
        <SendIcon />
      </TouchableOpacity>
    </View>
  );
};

export default AudioRecordingBar;
